<a (click)="changeAccountStatus()" class="{{sClass}}">{{currentAccountStatusLabel}}</a>

